export default {
  hostname: location.protocol + "//" + location.hostname + ":3000/api",
  //hostname: "https://informes.laboratoriollayllay.cl:3000/api",
};
